module.exports = __webpack_public_path__ + "media/src/assets/images/rds-logo-058377018d3b119e25fb8f8389947781.png";